import React from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  SecondaryNavAuditCA,
} from "../../../../components/AdminComponents/MenuItems";
import AuditTable from "./Tables/AuditTable";

const AuditTrail = () => {
  return (
    <CaSideNav props={CaAdminMenu}>
      <SecondaryNav2 menuItems={SecondaryNavAuditCA} />
      <AuditTable />
    </CaSideNav>
  );
};

export default AuditTrail;
